
export const filters = [
    {
        name: 'lastChar',
        func: (value) => {
            return value.substr(value.length-1)
        }
    },
    {
        name: 'remove',
        func: (value, word) => {
            return value.replace(word, '')
        }
    },
]
